import React, { useState, FC } from "react";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import getModalStyle from "../../../../util/getModalStyle";
import { StyledModalDiv } from "../../../../util/accordianStyles";

interface ConfimrationModalProps {
  handleClose: () => void;
  open: boolean;
  statusTableLocation: string;
  switchTable: (status: string) => void;
}

const SwitchQuoteStatusTableModal: FC<ConfimrationModalProps> = ({
  handleClose,
  open,
  statusTableLocation,
  switchTable
}) => {
  const [modalStyle] = useState(() => getModalStyle(50, 50));

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if(event.key === "Enter"){
      return switchTable(statusTableLocation)
    }
  }

  const body = (
    <StyledModalDiv style={modalStyle} onKeyDown={handleKeyDown}>
      <h3>This search result was found in the {statusTableLocation} table. Would you like to view in the {statusTableLocation} table?</h3>

      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <Button
          onClick={handleClose}
          size="small"
          variant="contained"
          color="inherit"
        >
          Cancel
        </Button>
        <Button
          onClick={() => switchTable(statusTableLocation)}
          size="small"
          variant="contained"
          color="primary"
        >
          Yes
        </Button>
      </div>
    </StyledModalDiv>
  );

  return (
    <Modal open={open} onClose={handleClose}>
      {body}
    </Modal>
  );
};

export default SwitchQuoteStatusTableModal;
